<template>
  <div>
    <el-dialog title="添加活动" :visible.sync="showdialog" width="1200px" @close="back">
      <el-row>
        <el-col class="base-col" :span="16" :offset="0">
          <el-form :model="form" ref="form" label-width="120px" :inline="false" size="mini">
            <el-form-item label="活动广告图">
              <el-upload class="avatar-uploader" action="/api/Upload/uploadFile/" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                <img v-if="form.thumbnail" :src="form.thumbnail" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="活动名称">
              <el-input v-model="form.name" maxlength="30" placeholder="30字以内的活动名称"></el-input>
            </el-form-item>
            <el-form-item label="集合地点">
              <div class="flex-box">
                <el-input v-model="form.address" placeholder="填写集合地点详细地址"></el-input>
                <el-button type="primary" size="mini" @click="loca">定位</el-button>
              </div>
              <div>
                <span class="text">经纬度：{{ location.lat }},{{ location.lng }}</span>
              </div>
            </el-form-item>
            <el-form-item label="活动时间">
              <el-date-picker v-model="form.startime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="报名截止时间">
              <el-date-picker v-model="form.applytime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"> </el-date-picker>
            </el-form-item>
            <el-form-item label="报名人数">
              <el-input type="number" v-model="form.click" placeholder="填写已报名人数"></el-input>
            </el-form-item>
            <el-form-item label="会员优惠">
              <el-input v-model="form.discounts" placeholder="填写会员优惠内容"></el-input>
            </el-form-item>
            <el-form-item label="带队导师">
              <div class="flex-box">
                <el-input v-model="form.tutorname" placeholder="点击右侧按钮选择活动导师" disabled></el-input>
                <tutor-list @getTutor="getTutor"></tutor-list>
              </div>
            </el-form-item>
            <el-form-item label="参观楼盘">
              <div class="pro-box">
                <el-row>
                  <el-col :span="8">参观时间</el-col>
                  <el-col :span="8">楼盘</el-col>
                  <el-col :span="4">选择楼盘</el-col>
                  <el-col :span="4">
                    <el-button type="primary" icon="el-icon-plus" circle @click="addproject"></el-button>
                  </el-col>
                </el-row>
                <el-row v-for="(item, index) in form.project" :key="index">
                  <el-col :span="6">
                    <el-time-picker class="pro-input" v-model="item.time" value-format="HH:mm" placeholder="任意时间点"> </el-time-picker>
                  </el-col>
                  <el-col :span="10">
                    <el-input class="pro-input" v-model="item.projectname" placeholder="点击右侧按钮选择楼盘" disabled></el-input>
                  </el-col>
                  <el-col :span="4">
                    <tutor-project @getProject="getProject(arguments)" :index="index"></tutor-project>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="danger" icon="el-icon-minus" circle @click="delproject(item, index)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="finish">保存</el-button>
              <el-button @click="showdialog = false">取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col class="base-col" :span="8">
          <div class="head">
            <div class="title">活动介绍</div>
          </div>
          <div class="table-box">
            <el-input type="textarea" v-model="form.intro" placeholder="这里填写活动的介绍等内容" size="mini" clearable></el-input>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import tutorAdd from "../../../components/tutor-add.vue";
import axios from "axios";
import TutorList from "../../../components/tutor-list.vue";
import TutorProject from "../../../components/tutor-project.vue";
export default {
  components: { tutorAdd, TutorList, TutorProject },
  data() {
    return {
      showdialog: true,
      form: {
        thumbnail: "",
        name: "",
        address: "",
        startime: "",
        applytime: "",
        tutorname: "",
        tutorid: "",
        intro: "",
        click: "",
        discounts: "",
        project: [
          {
            time: "",
            projectname: "",
            projectid: ""
          }
        ]
      },
      location: {}
    };
  },
  methods: {
    getProject(data) {
      let [item, index] = data;
      this.form.project[index].projectname = item.name;
      this.form.project[index].projectid = item._id["$oid"];
    },
    getTutor(item) {
      this.form.tutorname = item.name;
      this.form.tutorid = item._id["$oid"];
    },
    delproject(item, index) {
      if (item.projectid) {
        this.$confirm("已绑定楼盘：" + item.projectname + " 是否确定删除").then(
          (confirm) => {
            this.form.project.splice(index, 1);
          },
          (cancel) => {}
        );
        return;
      }
      this.form.project.splice(index, 1);
    },
    addproject() {
      var obj = {
        time: "",
        projectname: "",
        projectid: ""
      };
      this.form.project.push(obj);
    },
    loca() {
      var address = this.form.address;
      if (!address) {
        this.$message.error("请先输入地址");
        return;
      }
      if (address.length < 8) {
        this.$message.error("请输入8个字以上的地址");
        return;
      }
      var url = "/qqmap/ws/geocoder/v1/?address=" + address + "&key=BUGBZ-NR4KP-2AFDK-LJLEB-W2LVV-S5FGH";
      axios.get(url).then((res) => {
        let { data } = res;
        if (data.message != "query ok") {
          this.$message.error(data.message);
          return;
        }
        let result = data.result;
        let { location } = result;
        this.location = location;
        this.location.address = this.form.address;
      });
    },
    back() {
      this.$router.go(-1);
    },
    confirm() {
      var params = {
        thumbnail: this.form.thumbnail,
        name: this.form.name,
        location: JSON.stringify(this.location),
        startime: this.form.startime,
        applytime: this.form.applytime,
        tutorid: this.form.tutorid,
        intro: this.form.intro,
        click: this.form.click,
        discounts: this.form.discounts,
        project: JSON.stringify(this.form.project)
      };
      this.$api.addActivity(params).then((data) => {
        this.$message.success(data);
      });
    },
    finish() {
      this.confirm();
      this.showdialog = false;
    },
    handleAvatarSuccess(response) {
      let { data, msg } = response;
      if (data) {
        this.$message.success(msg);
        this.form.thumbnail = data;
        this.$forceUpdate();
      } else {
        this.$message.error(msg);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isPNG) {
        this.$message.error("只能上传图片，不能上传其他文件!");
      }
      // if (!isLt2M) {
      //     this.$message.error('上传的图片大小不能超过 1MB!');
      // }

      return isJPG || isPNG;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #f7f7f7;
}
.head {
  .title {
    line-height: 28px;
  }
}
.table-box {
  margin-top: 10px;
}
.base-col {
  border-right: 1px solid #eee;
  padding: 0 20px;
  box-sizing: border-box;
  &:last-child {
    border-right: none;
  }
}
.pro-box {
  .pro-input {
    width: 90%;
  }
}
::v-deep .el-textarea__inner {
  height: 200px;
}
::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 350px;
  height: 176px;
  line-height: 176px;
  text-align: center;
}
.avatar {
  width: 350px;
  height: 176px;
  display: block;
}
</style>
